module.exports = __webpack_public_path__ + "img/warm-water.80f40e3d.jpg";